import styled from 'styled-components';
import { Button } from 'antd';
import * as Icons from '@ant-design/icons';
import { AA_LINK_ON_LIGHT, AA_SURFACE } from '~/modules/Helper/contrast.helper';

function primaryBg(theme) {
  return (theme && theme.corTema) || AA_LINK_ON_LIGHT;
}

export const Icon = styled(Icons.EnvironmentOutlined)`
  font-size: 14px;
`;

export const ImageButton = styled(Button)`
  && {
    display: flex;
    align-items: center;
    height: 40px;
    width: 40px;
    padding: 12px;
  }

  &&.ant-btn-primary {
    color: ${AA_SURFACE};
    background-color: ${({ theme }) => primaryBg(theme)};
    border-color: ${({ theme }) => primaryBg(theme)};
  }

  &&.ant-btn-primary:hover,
  &&.ant-btn-primary:focus {
    color: ${AA_SURFACE};
    background-color: ${({ theme }) => primaryBg(theme)};
    border-color: ${({ theme }) => primaryBg(theme)};
    filter: brightness(0.92);
  }
`;
